export default class SimpleSearchResultCounts {
    currentPage!: number;
    itemCount!: number;
    itemsPerPage!: number;
    totalItems!: number;
    totalPages!: number;
}
